<template>
  <div class="space-y-4">
    <div class="space-y-10 rounded-md bg-white p-6 shadow-md">
      <div class="w-full">
        <label for="filter" class="sr-only">Buscar comprobantes...</label>
        <div class="flex rounded-md shadow-sm hover:shadow-lg">
          <div class="relative flex-grow focus-within:z-10">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <input
              id="filter"
              class="block w-full appearance-none rounded-md border border-gray-400 py-2 pl-10 pr-3 text-gray-900 placeholder-gray-700 transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm"
              placeholder="Buscar comprobantes..."
              v-model="filtros.busqueda"
            />
          </div>
        </div>
      </div>
      <div class="space-y-2">
        <div class="text-lg font-semibold text-gray-700">
          Búsqueda de comprobantes por organismo
        </div>
        <div
          class="grid grid-cols-1 gap-4 rounded-md border border-gray-200 p-4 sm:grid-cols-2 lg:grid-cols-3"
        >
          <div
            @click="filtros.organismo = 'COLESCBA'"
            class="flex cursor-pointer justify-center rounded border border-gray-300 px-2 py-4 transition duration-150 ease-in-out hover:bg-gray-50"
            :class="
              filtros.organismo == 'COLESCBA' ? 'bg-gray-50 shadow-sm' : 'shadow-md hover:shadow-lg'
            "
          >
            <img src="@/assets/logo-colescba.png" class="object-contain" />
          </div>
          <div
            v-if="this.userHasAnyRole(['NOTARIO'])"
            @click="filtros.organismo = 'CAJA'"
            class="flex cursor-pointer justify-center rounded border border-gray-300 px-2 py-4 transition duration-150 ease-in-out hover:bg-gray-50"
            :class="
              filtros.organismo == 'CAJA' ? 'bg-gray-50 shadow-sm' : 'shadow-md hover:shadow-lg'
            "
          >
            <img src="@/assets/Logo-Caja-de-Seguridad-Social.png" class="object-contain" />
            <!-- <div class="text-center text-3xl text-pba font-extrabold">DPPJ</div>
            <div class="text-center text-base text-gray-700 font-semibold">Dirección Provincial de Personas Jurídicas</div> -->
          </div>
          <div
            @click="filtros.organismo = 'RPBA'"
            class="flex cursor-pointer justify-center rounded border border-gray-300 px-2 py-4 transition duration-150 ease-in-out hover:bg-gray-50"
            :class="
              filtros.organismo == 'RPBA' ? 'bg-gray-50 shadow-sm' : 'shadow-md hover:shadow-lg'
            "
          >
            <img src="@/assets/logo-registro.png" class="object-contain" />
            <!--  <div class="text-center text-3xl text-pba font-extrabold">RPBA</div>
            <div class="text-center text-base text-gray-700 font-semibold">Registro de la Propiedad de la Provincia de Buenos Aires</div> -->
          </div>
          <div
            @click="filtros.organismo = 'ARBA'"
            class="flex cursor-pointer justify-center rounded border border-gray-300 px-2 py-4 transition duration-150 ease-in-out hover:bg-gray-50"
            :class="
              filtros.organismo == 'ARBA' ? 'bg-gray-50 shadow-sm' : 'shadow-md hover:shadow-lg'
            "
          >
            <img src="@/assets/logo-arba.png" class="object-contain" />
            <!--  <div class="text-center text-3xl text-pba font-extrabold">ARBA</div>
            <div class="text-center text-base text-gray-700 font-semibold">Agencia de Recaudación de la Provincia de Buenos Aires</div> -->
          </div>
          <div
            @click="filtros.organismo = 'DPPJ'"
            class="flex cursor-pointer justify-center rounded border border-gray-300 px-2 py-4 transition duration-150 ease-in-out hover:bg-gray-50"
            :class="
              filtros.organismo == 'DPPJ' ? 'bg-gray-50 shadow-sm' : 'shadow-md hover:shadow-lg'
            "
          >
            <img src="@/assets/logo-dppj.png" class="object-contain" />
            <!-- <div class="text-center text-3xl text-pba font-extrabold">DPPJ</div>
            <div class="text-center text-base text-gray-700 font-semibold">Dirección Provincial de Personas Jurídicas</div> -->
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-200"
      enter-class="opacity-0"
      leave-to-class="opacity-0"
      mode="out-in"
    >
      <div v-if="filtrosAplicados.length > 0" class="space-y-4 rounded-md bg-white p-6 shadow-md">
        <div class="flex items-center space-x-2 text-lg text-gray-700">
          <div class="font-semibold">Mostrando:</div>
          <div class="flex space-x-2">
            <span
              class="flex items-center space-x-2 rounded-full bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-700"
              v-for="(filtro, index) in filtrosAplicados"
              :key="index"
            >
              <span class=""> {{ filtro.label }}: {{ filtro.value }} </span>
              <SolidXIcon
                @click="filtros[filtro.key] = null"
                class="inline h-4 w-4 cursor-pointer"
              />
            </span>
          </div>
          <!-- <div
            class=""
            v-else
          >Todos los comprobantes</div> -->
        </div>
        <transition-group
          enter-active-class="transition-opacity duration-500"
          leave-active-class="opacity-0"
          enter-class="opacity-0"
          leave-to-class="opacity-0"
          mode="out-in"
          tag="div"
          @before-enter="scrollToElement"
          @appear="scrollToElement"
          class="space-y-4"
        >
          <Empty v-if="tramitesFiltrados.length == 0" :key="'empty'" />
          <div
            v-for="tramite in tramitesFiltrados"
            :key="tramite.idTramite"
            class="flex flex-col items-center space-x-2 space-y-2 rounded border border-gray-300 px-2 py-4 shadow-md md:flex-row md:justify-between md:space-y-0"
          >
            <div class="w-full">
              <div class="text-base font-semibold text-gray-700">{{ tramite.nombre }}</div>
              <div class="text-base font-medium text-gray-700">{{ tramite.titulo }}</div>
              <div class="text-sm text-gray-500">{{ tramite.descripcion }}</div>
              <div class="text-sm font-bold text-gray-700">{{ tramite.observaciones }}</div>
            </div>
            <div>
              <button
                v-if="tramite.organismo !== 'CAJA'"
                @click="
                  $router.push({
                    name: 'formulario-comprobante',
                    params: { idFormulario: tramite.idFormulario },
                  })
                "
                class="space-x-2 whitespace-nowrap rounded-md border border-blue-brand-700 bg-blue-brand-500 px-3 py-2 text-sm font-medium text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700"
              >
                Generar comprobante
              </button>
              <button
                v-else
                class="space-x-2 whitespace-nowrap rounded-md border border-blue-brand-700 bg-blue-brand-500 px-3 py-2 text-sm font-medium text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700"
                @click="
                  $router.push({
                    name: 'ver-comprobantes',
                    params: {
                      categoriaDeudaId: tramite.categoriaDeudaId,
                    },
                  })
                "
              >
                Ver comprobantes
              </button>
            </div>
          </div>
        </transition-group>
      </div>
    </transition>
    <!-- <button @click="pruebita">pruebita</button> -->
  </div>
</template>

<script>
import { useAcreditacionServicio, useSession } from '@colescba/ui'

import Empty from '@/components/Core/Empty'
import { mapState } from 'vuex'

export default {
  name: 'GenerarComprobante',

  components: { Empty },

  mixins: [useSession(), useAcreditacionServicio()],

  data() {
    return {
      filtros: {
        organismo: null,
        busqueda: null,
      },
    }
  },

  computed: {
    ...mapState({
      tramites: state => state.app.tramites,
      formularios: state => state.app.formularios,
    }),
    tramitesVisibles() {
      return this.tramites.filter(t => {
        const formulario = this.formularios.find(f => f.idFormulario === t.idFormulario)
        return !formulario.private || this.userHasAnyRole(formulario.roles)
      })
    },
    tramitesFiltrados() {
      if (this.filtrosAplicados.length == 0) {
        return []
      }
      let items = this.tramitesVisibles

      const normalizeString = str => {
        return str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      }

      if (this.filtros.organismo) {
        items = items.filter(i => i.organismo === this.filtros.organismo)
      }

      if (this.filtros.busqueda) {
        const busquedaNormalizada = normalizeString(this.filtros.busqueda)
        items = items.filter(i => {
          const nombreNormalizado = i.nombre ? normalizeString(i.nombre) : ''
          const tituloNormalizado = i.titulo ? normalizeString(i.titulo) : ''
          return (
            nombreNormalizado.includes(busquedaNormalizada) ||
            tituloNormalizado.includes(busquedaNormalizada)
          )
        })
      }

      return items
    },
    filtrosAplicados() {
      let filtros = []
      if (this.filtros.organismo)
        filtros.push({ label: 'Organismo', value: this.filtros.organismo, key: 'organismo' })
      if (this.filtros.busqueda)
        filtros.push({ label: 'Búsqueda', value: this.filtros.busqueda, key: 'busqueda' })
      return filtros
    },
  },
  methods: {
    /*     pruebita() {
      console.log('tramites', this.tramites)
      console.log('tramitesVisibles', this.tramitesVisibles)
      //console.log('formularios', this.formularios)
    }, */
    scrollToElement(el, done) {
      this.$nextTick(
        () => el.scrollIntoView({ behavior: 'smooth' })
        //console.log(el, done)
      )
    },
  },
}
</script>
